import { internal, template } from '../../vendor/elix.js';
import TpChipSelect from './tp-chip-select.js';

class TpChipSportSelect extends TpChipSelect {

  [internal.render](changed) {
    this.renderSportIcon();
    super[internal.render](changed);
  }

  renderSportIcon() {
    let icon = this.querySelector('tp-sport-icon');

    if (this.empty) {
      if (icon) { icon.remove(); }
      return;
    }

    if (!icon) {
      icon = document.createElement('tp-sport-icon');
      icon.slot = 'leading';
      this.appendChild(icon);
    }

    const option = this.selectedOption;
    icon.sportName = option.getAttribute('sport-name') || option.value || option.textContent;
  }

  get [internal.template]() {

    return template.concat(
      super[internal.template],
      template.html`
        <style>
          slot[name=leading]::slotted(*) {
            color: white;
            font-size: 24px;
          }
        </style>
      `
    );
  }
}

export default TpChipSportSelect;
